import React from 'react';
import MarkdownPreview from '@uiw/react-markdown-preview';
import { Accordion } from '@groupby/ui-components';
import { PageTitle, SearchBar } from '@/pages/release-notes/ui';
import { HighlightedText, StyledReleaseNotesCard, StyledReleaseNotesPageContainer, TypographyShowResults, } from '@/pages/release-notes/release-notes.styles';
import Loading from '@/components/loading.component';
import { renderBoldText, useLocalization } from '@/localization';
import { useReleaseNotesFetch, useReleaseNotesSearch } from './hooks';
import { ReleaseNotesImage } from './ui/release-notes-image.component';
const highlightText = (text, phrase) => {
    if (!phrase)
        return text;
    const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escapeRegExp(phrase)})`, 'gi');
    const parts = text.split(regex);
    return parts.map((part, index) => (regex.test(part) ? <HighlightedText key={index}>{part}</HighlightedText> : part));
};
export function ReleaseNotes() {
    const { formatMessage: t, formatNumber } = useLocalization();
    const { isLoading } = useReleaseNotesFetch();
    const { searchValue, setSearchValue, filteredItems, openState, handleSearch, toggleAccordion, } = useReleaseNotesSearch();
    return (<StyledReleaseNotesPageContainer className="release-notes-page-container">
      <PageTitle />
      <div className="release_notes_container">
        <SearchBar search={searchValue} setSearch={setSearchValue} onSubmit={handleSearch}/>
        <TypographyShowResults>
          {t({ key: 'REF_APP_TOTAL_RESULTS', values: { total: formatNumber(filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length), highlight: renderBoldText } })}
        </TypographyShowResults>
        {isLoading
            ? <Loading isLoading/>
            : (filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.length) ? filteredItems.map((item) => (<StyledReleaseNotesCard key={item.releaseName}>
              <Accordion isOpened={openState[item.fileName]} onToggle={() => toggleAccordion(item.fileName)} heading={<span>
                    Date: {item.isReleaseDateHighlighted ? highlightText(item.releaseDate, searchValue) : item.releaseDate}
                    {' | '}
                    Name: {item.isReleaseNameHighlighted ? highlightText(item.releaseName, searchValue) : item.releaseName}
                  </span>}>
                <hr />
                <MarkdownPreview components={{
                    img: ({ src }) => <ReleaseNotesImage imageUrl={src}/>,
                }} wrapperElement={{ 'data-color-mode': 'light' }} source={(item.highlightedContent || item.content) || 'Loading...'}/>
              </Accordion>
            </StyledReleaseNotesCard>)) : <p>No data found</p>}
      </div>
    </StyledReleaseNotesPageContainer>);
}
